"use strict";

import * as React from 'react';
export const DrawerProgressContext = /*#__PURE__*/React.createContext(undefined);
//# sourceMappingURL=DrawerProgressContext.js.map